import * as React from 'react'
import { theme } from '../theme'

interface Props {
    onClick: () => void
    disabled?: boolean
}

export const SaveAsNewButton = ({
    onClick,
    disabled = false
}: Props): JSX.Element => {
    const [isHovered, setIsHovered] = React.useState(false)
    const [showTooltip, setShowTooltip] = React.useState(false)

    return (
        <div style={{ position: 'relative' }}>
            <button
                onClick={onClick}
                disabled={disabled}
                onMouseEnter={() => {
                    setIsHovered(true)
                    setShowTooltip(true)
                }}
                onMouseLeave={() => {
                    setIsHovered(false)
                    setShowTooltip(false)
                }}
                style={{
                    padding: '10px 20px',
                    borderRadius: theme.borderRadius.sm,
                    border: 'none',
                    backgroundColor: isHovered ? 'rgba(47, 123, 118, 0.9)' : '#2F7B76',
                    color: 'white',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    fontSize: '14px',
                    fontWeight: 500,
                    transition: 'background-color 0.2s ease',
                    opacity: disabled ? 0.6 : 1,
                }}
            >
                Save as New Image
            </button>
            {showTooltip && (
                <div
                    style={{
                        position: 'absolute',
                        bottom: '100%',
                        right: 0,
                        marginBottom: '8px',
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        color: 'white',
                        padding: '8px 12px',
                        borderRadius: theme.borderRadius.sm,
                        fontSize: '12px',
                        whiteSpace: 'nowrap',
                        zIndex: 1000,
                        pointerEvents: 'none',
                    }}
                >
                    Saves all dimension variants
                </div>
            )}
        </div>
    )
}
